import {ErrorResponse, SessionErrorResponse} from "../types/StudioAPITypes";
import {LogLevel, RequestOptions} from "../types/Types";
import {DEFAULT_REQUEST_OPTIONS} from "../utils/constants";

export const POST_SESSION_BASE = 'POST_SESSION';
export const POST_SESSION_BEGIN   = `${POST_SESSION_BASE}_BEGIN`;
export const POST_SESSION_SUCCESS = `${POST_SESSION_BASE}_SUCCESS`;
export const POST_SESSION_FAILURE = `${POST_SESSION_BASE}_FAILURE`;
export const DELETE_SESSION_BASE = `DELETE_SESSION`;
export const DELETE_SESSION_BEGIN = `${DELETE_SESSION_BASE}_BEGIN`;
export const DELETE_SESSION_SUCCESS = `${DELETE_SESSION_BASE}_SUCCESS`;
export const DELETE_SESSION_FAILURE = `${DELETE_SESSION_BASE}_FAILURE`;
export const FETCH_SESSION_BASE = 'FETCH_SESSION';
export const FETCH_SESSION_BEGIN = `${FETCH_SESSION_BASE}_BEGIN`;
export const FETCH_SESSION_SUCCESS = `${FETCH_SESSION_BASE}_SUCCESS`;
export const FETCH_SESSION_FAILURE = `${FETCH_SESSION_BASE}_FAILURE`;
export const UPDATE_LOGIN_MESSAGE = 'UPDATE_LOGIN_MESSAGE';
export const UPDATE_RECAPTCHA_ID = 'UPDATE_RECAPTCHA_ID';

export const postSessionBegin = (options: RequestOptions = DEFAULT_REQUEST_OPTIONS) => ({
  type: POST_SESSION_BEGIN,
  options: options
});

export const postSessionSuccess = (session: any) => ({
  type: POST_SESSION_SUCCESS,
  payload: { session }
});

export const postSessionError = (error: SessionErrorResponse, failedAttempts: number, showRecaptcha: boolean) => ({
  type: POST_SESSION_FAILURE,
  payload: { error },
  failedAttempts: failedAttempts,
  showRecaptcha: showRecaptcha
});

export const deleteSessionBegin = (options: RequestOptions = DEFAULT_REQUEST_OPTIONS) => ({
  type: DELETE_SESSION_BEGIN,
  options: options
});

export const deleteSessionSuccess = () => ({
  type: DELETE_SESSION_SUCCESS
});

export const deleteSessionFailure = (error: ErrorResponse) => ({
  type: DELETE_SESSION_FAILURE,
  payload: { error }
});

export const fetchSessionBegin = (options: RequestOptions = DEFAULT_REQUEST_OPTIONS) => ({
  type: FETCH_SESSION_BEGIN,
  options: options
});

export const fetchSessionSuccess = (session: any) => ({
  type: FETCH_SESSION_SUCCESS,
  payload: { session }
});

export const fetchSessionFailure = (error: ErrorResponse) => ({
  type: FETCH_SESSION_FAILURE,
  payload: { error }
});

export const updateMessage = (messageText: string, messageLevel: LogLevel) => ({
  type: UPDATE_LOGIN_MESSAGE,
  message: {
    text: messageText,
    level: messageLevel
  }
});

export const updateRecaptchaId = (id: number) => ({
  type: UPDATE_RECAPTCHA_ID,
  id: id
})
